module.exports = __webpack_public_path__ + "static/media/sulochana.debd6ec1.svg";